import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field} from 'redux-form';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {getGetHeaders} from '../shared/serverFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A Virtualized SelectInput form component with Product Unit choices populated from Product Type value.
 *
 */
class ProductUnitsByTypeSelectInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sourceParam: null,
            selectChoices: [],
            selectedId: null,
            selectedProductUnit: null
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.productType !== this.props.productType) {
            this.setState({
                selectChoices: [],
                selectedId: null,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.productType !== this.props.productType) {
            this.fetchData();
        }
    }

    fetchData = () => {
        // Assemble the URI
        const params = {
            filter: {
                type: encodeURIComponent(this.props.productType)
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductUnitsForAlias.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        // Retrieve the data and assign results to the Select choices
        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data.payload) {
                let choices = this.assembleChoiceNames(result.data.payload);
                this.setState({
                    selectChoices: choices
                });
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    };

    assembleChoiceNames(choices) {
        for (let choice of choices) {
            const id = choice.id;
            const name = (choice.name) ? ' - ' + choice.name : '';
            const unit = (choice.unit_type) ? ' (' + choice.unit_type + ')' : '';
            const brand = (choice.brand) ? ' - ' + choice.brand : '';
            choice.display_name = id + name + unit + brand;
        }
        return choices;
    }

    handleSelectChange = (event, index) => {
        const selectedId = index;
        // Retrieve the Product Unit from the choices list based on the selected ID
        if (selectedId) {
            const productUnit = this.state.selectChoices.find(p => p.id === selectedId);
            if (productUnit) {
                this.setState({
                    selectedId: selectedId
                }, () => {
                    // Update the parent component with the selection
                    this.props.onSelectProductUnit(productUnit);
                });
            }
        } else {
            this.setState({
                selectedId: null
            }, () => {
                this.props.onSelectProductUnit(null);
            });
        }
    };

    render() {
        return (
            <Field name="product_unit_select"
                   component={VirtualizedSelectInput}
                   choices={this.state.selectChoices}
                   label={this.props.label}
                   optionText="display_name"
                   onChange={this.handleSelectChange}
                   allowEmpty
                   options={{
                       className: "full-width",
                       clearable: false,
                       placeholder: "Select a Product Unit",
                   }}
            />
        );
    }
}

ProductUnitsByTypeSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    onSelectProductUnit: PropTypes.func.isRequired,
    productType: PropTypes.string.isRequired,
};

ProductUnitsByTypeSelectInput.defaultProps = {
    addField: true,
};

export default ProductUnitsByTypeSelectInput;



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitsByTypeSelectInput.js